import { atom, selector } from "recoil";
import { getJobs } from "./sentiment.api";
import { currentProject, projectUpdate } from "../project";

export const asyncGetResentJob = selector({
  key: "SENTIMENT/resent_job",
  get: async ({ get }) => {
    get(projectUpdate);
    const pid = get(currentProject);

    if (isNaN(pid) || pid === 0) return;

    let jobs: { id?: number } = {};
    try {
      jobs = Object.assign(
        (await getJobs(pid, { status: "IN_PROGRESS" })).results[0] ?? {},
        (await getJobs(pid, { status: "READY" })).results[0] ?? {}
      );
    } catch (e) {
      console.log(e);
    }

    return jobs;
  },
});

////////////////////////////////////////////////////////////////////////////////
// SENTIMENT SUMMARY 데이터
////////////////////////////////////////////////////////////////////////////////

export const aspectPageState = atom({
  key: "SENTIMENT/sentiment_summary/pages",
  default: 1,
});

export const aspectMaxPageState = atom({
  key: "SENTIMENT/sentiment_state/max_page",
  default: 1,
});
